import React, {useState} from 'react';
import {Alert} from "react-bootstrap";
import {useNavigate} from "react-router";
import styles from './ManualPricingTable.module.scss';
import useGet from "../hooks/useGet";
import Loading from "../Loading";
import ManualPlanDisplay from "./ManualPlanDisplay";
import {routes} from "../../utils";
import SeatSelectorModal from "./seat-selector/SeatSelectorModal";
import {isCustom, isGroupProduct, isIndividualProduct, StripePriceObject} from "./stripePriceObject";
import useAuth from "../hooks/useAuth";
import IndividualPriceModal from "./IndividualPriceModal";
import FreeProductModal from "./FreeProductModal";


type PriceWithDownSell = StripePriceObject & { downsell?: StripePriceObject };
// Price sets for an individual has the downsell from an annual price with
// discount to a monthly price without discount.
type MonhtlyPriceWithDownSell = StripePriceObject & { downsell: StripePriceObject };

export default function ManualPricingTable({ endpoint, groupId, prePrices = [], postPrices = [], bestValueIndex, filterScope, center }: {
    endpoint: string;
    groupId?: number;
    center?: boolean;
    bestValueIndex?: number;
    filterScope?: boolean;
    prePrices?: StripePriceObject[];
    postPrices?: StripePriceObject[];
}) {
    const {data: prices, isLoading, error} = useGet<PriceWithDownSell[]>({
        endpoint,
        cacheTime: 1000,
    });
    const [showDownSellForSelectedPrice, setShowDownSellForSelectedPrice] = useState(false);
    const [selectedPrice, setPrice] = useState<PriceWithDownSell | null>(null);
    const navigate = useNavigate();
    const { user } = useAuth();

    return (
        <>
            {selectedPrice && selectedPrice.unit_amount === 0 && (
                <FreeProductModal onClose={() => setPrice(null)} />
            )}
            {selectedPrice && selectedPrice.unit_amount > 0 && (
                isGroupProduct(selectedPrice)
                    ? (
                        <SeatSelectorModal
                            onCancel={() => setPrice(null)}
                            selectedPrice={selectedPrice}
                            initGroupId={groupId}
                        />
                    ) : (
                        <IndividualPriceModal
                            price={selectedPrice as MonhtlyPriceWithDownSell}
                            onCancel={() => setPrice(null)}
                            defaultShowDownSell={showDownSellForSelectedPrice}
                        />
                    )
            )}
            {isLoading && <div style={{minHeight: 500}}><Loading /></div>}
            {error && <Alert variant="danger">{error}</Alert>}
            <div className={`${styles.Table} ${center ? styles.Center : styles.Left}`}>
                {Array.isArray(prices) && [...prePrices, ...prices, ...postPrices]?.map((price, idx) => (
                    <ManualPlanDisplay
                        filterScope={filterScope}
                        price={price}
                        key={price.id || idx}
                        onSelect={(showDownSell) => {
                            if (isCustom(price)) {
                                window.location.href = 'mailto:info@fearlessleague.com';
                            } else {
                                if (!user) {
                                    navigate(routes.signUp);
                                } else if (isIndividualProduct(price) || isGroupProduct(price)) {
                                    setShowDownSellForSelectedPrice(showDownSell);
                                    setPrice(price);
                                }
                            }
                        }}
                        isBestValue={idx === bestValueIndex}
                    />
                ))}
            </div>
        </>
    )
}
